export default __webpack_public_path__ + "0fcfae97c406944dbedfc38513d0d30a.svg";